import React from "react";

type AuthLayoutHeaderBackgroundProps = React.JSX.IntrinsicElements["svg"];

const AuthLayoutHeaderBackground: React.FC<AuthLayoutHeaderBackgroundProps> = (
  props
) => {
  return (
    <svg
      width="396"
      height="128"
      viewBox="0 0 396 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M157.238 -6.9711C200.049 152.802 364.276 247.618 524.048 204.808C683.821 161.997 778.637 -2.23015 735.826 -162.003C693.015 -321.776 528.788 -416.593 369.016 -373.782C209.243 -330.971 114.427 -166.744 157.238 -6.9711Z"
        stroke="#ADECF3"
      />
      <path
        d="M157.24 -6.97186C159.83 2.69238 170.228 9.9237 187.172 14.6015C204.078 19.2688 227.321 21.3412 255.264 20.8313C311.144 19.8115 385.706 8.46834 465.698 -12.9655C545.69 -34.3994 615.935 -61.8569 664.838 -88.9135C689.292 -102.444 708.385 -115.86 720.692 -128.355C733.027 -140.878 738.417 -152.34 735.827 -162.004C733.238 -171.668 722.839 -178.899 705.895 -183.577C688.99 -188.245 665.747 -190.317 637.803 -189.807C581.924 -188.787 507.362 -177.444 427.369 -156.01C347.377 -134.576 277.133 -107.119 228.23 -80.0622C203.775 -66.532 184.682 -53.1158 172.375 -40.6211C160.04 -28.098 154.65 -16.6361 157.24 -6.97186Z"
        stroke="#ADECF3"
      />
      <path
        d="M184.374 59.1706C186.899 68.5938 196.992 75.6593 213.435 80.2457C229.839 84.8217 252.388 86.877 279.495 86.4211C333.7 85.5092 406.014 74.5577 483.581 53.7736C561.148 32.9896 629.249 6.31691 676.648 -19.9959C700.351 -33.1542 718.851 -46.2087 730.77 -58.374C742.716 -70.567 747.925 -81.7324 745.4 -91.1557C742.875 -100.579 732.782 -107.644 716.339 -112.231C699.935 -116.807 677.386 -118.862 650.279 -118.406C596.074 -117.494 523.76 -106.543 446.193 -85.7587C368.626 -64.9746 300.524 -38.3019 253.126 -11.9891C229.423 1.16923 210.923 14.2237 199.004 26.389C187.058 38.582 181.849 49.7474 184.374 59.1706Z"
        stroke="#ADECF3"
      />
      <path
        d="M280.882 159.428C282.823 166.67 290.544 172.143 303.189 175.719C315.799 179.285 333.133 180.912 353.977 180.601C395.656 179.98 451.25 171.612 510.873 155.636C570.497 139.66 622.827 119.109 659.233 98.808C677.439 88.6554 691.637 78.579 700.775 69.1863C709.938 59.7665 713.888 51.1668 711.947 43.924C710.007 36.6813 702.286 31.2086 689.64 27.6327C677.031 24.067 659.696 22.4398 638.853 22.7505C597.174 23.3719 541.579 31.7397 481.956 47.7157C422.333 63.6917 370.003 84.2422 333.597 104.544C315.391 114.696 301.192 124.773 292.055 134.165C282.891 143.585 278.942 152.185 280.882 159.428Z"
        stroke="#ADECF3"
      />
      <path
        d="M228.129 117.093C230.393 125.544 239.5 131.884 254.385 135.988C269.231 140.081 289.649 141.896 314.202 141.443C363.299 140.538 428.817 130.565 499.11 111.73C569.403 92.8947 631.129 68.7729 674.102 45.0084C695.591 33.1243 712.366 21.3433 723.177 10.3754C734.016 -0.621064 738.732 -10.6645 736.467 -19.1161C734.203 -27.5677 725.097 -33.9075 710.212 -38.0111C695.365 -42.104 674.947 -43.9195 650.395 -43.4666C601.297 -42.561 535.78 -32.5878 465.487 -13.7529C395.194 5.08204 333.467 29.2039 290.495 52.9683C269.005 64.8524 252.231 76.6334 241.42 87.6014C230.58 98.5978 225.864 108.641 228.129 117.093Z"
        stroke="#ADECF3"
      />
      <path
        d="M318.503 180.404C320.151 186.553 326.755 191.211 337.638 194.247C348.484 197.272 363.404 198.634 381.355 198.332C417.248 197.728 465.142 190.476 516.521 176.709C567.9 162.942 613.003 145.276 644.39 127.852C660.087 119.138 672.327 110.499 680.207 102.456C688.114 94.3854 691.504 87.0496 689.857 80.8999C688.209 74.7502 681.605 70.0923 670.722 67.0566C659.876 64.0312 644.956 62.6696 627.005 62.9716C591.112 63.5753 543.218 70.8278 491.839 84.5948C440.46 98.3617 395.356 116.028 363.97 133.452C348.273 142.165 336.033 150.805 328.153 158.848C320.246 166.918 316.855 174.254 318.503 180.404Z"
        stroke="#ADECF3"
      />
      <g opacity="0.24" filter="url(#filter0_f_8334_70703)">
        <circle cx="373.228" cy="-43.5666" r="132.343" fill="#41D3E7" />
      </g>
      <defs>
        <filter
          id="filter0_f_8334_70703"
          x="0.885254"
          y="-415.909"
          width="744.685"
          height="744.686"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="120"
            result="effect1_foregroundBlur_8334_70703"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AuthLayoutHeaderBackground;
